import React, { Component } from 'react'

export class Synopsisofproject extends Component {
    render() {
        return (
                <div className="box">
                <div className="box-body">
                    <div className="box-header">
                        <h3 className="box-title">Synopsis of Project - Major Scope of Work</h3>
                    </div>
                    <div className="col-md-12">
                        <h3 className="text-center">Master Update</h3>
                        <form action="partworksdetails/savesynopsis_of_project_master">
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Item</label>
                                <select name="item_id" id="item_id" className="form-control">
                                    <option value="">Select Item</option>
                                </select>
                            </div>
                            </div>
                            <div className="col-md-3">
                            <div className="form-group">
                                <label>Quantity as per BoQ</label> 
                                <input type="text" name="quantity" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-3">
                            <div className="form-group">
                                <label>Financial Provision</label> 
                                <input type="text" name="financial_provision" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-2" style={{padding: '2.3%'}}>
                            <input type="submit" className="btn btn-primary" value="Update" />
                    </div>
                    </form>	
                </div>
                <div className="col-md-12 table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr className="bg-gray">
                            <th>Sr. No.</th>
                            <th>Item</th>
                            <th>Quantity as per BoQ</th>
                            <th>Achieved till Date</th>
                            <th>Balance</th>
                            <th>Financial Provision (in %age)</th>
                            <th>% Completion</th>
                            <th>Remarks</th>
                            </tr>
                        </thead>
                        <tfoot>
                        <tr>
                            <td colspan="5" className="text-right">Total </td>
                            <td className="text-right"></td>
                            <td className="text-right"></td>
                            <td></td>
                        </tr>
                        </tfoot>							
                    </table>
                </div>
                <div className="col-md-12">
                    <h3 className="text-center">Using Entry</h3>
                    <div id="error_msg_display"></div>
                    <form action="partworksdetails/savesynopsis_of_project">
                        <div className="col-md-4">
                            <div className="form-group">
                            <label>Item</label>
                            <select name="item_id" className="form-control">
                                <option value="">Select Item</option>
                            </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                            <label>Used Date</label> 
                            <input type="text" placeholder="DD-MM-YYYY" name="used_date" className="form-control" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                            <label>Quantity</label> 
                            <input type="text" name="quantity" className="form-control" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                            <label>Remark</label> 
                            <input type="text" name="remark" className="form-control" />
                            </div>
                        </div>
                        <div className="col-md-4" style={{ padding: '2.3%'}} >
                        <input type="submit" className="btn btn-primary" value="Save" />
                </div>
                </form>	
                </div>
                <h3 className="text-center">Item List</h3>
                <div className="col-md-12 table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr className="bg-gray">
                            <th>Sr No</th>
                            <th>Item Name</th>
                            <th>Used Date</th>
                            <th>Quantity</th>
                            <th>Remark</th>
                            <th>Edit</th>
                        </tr>
                    </thead>
                </table>
                </div>
                </div>
                </div>
        )
    }
}

export default Synopsisofproject
